/**
 * Words and short phrases used across many screens. Keep this small: a string
 * belongs here only if several features need exactly the same wording.
 * Anything feature-specific goes in that feature's namespace.
 */
const common = {
  actions: {
    add: "Add",
    back: "Back",
    cancel: "Cancel",
    close: "Close",
    confirm: "Confirm",
    copy: "Copy",
    copied: "Copied",
    create: "Create",
    delete: "Delete",
    done: "Done",
    download: "Download",
    edit: "Edit",
    keep: "Keep",
    move: "Move",
    open: "Open",
    remove: "Remove",
    rename: "Rename",
    retry: "Retry",
    save: "Save",
    saving: "Saving…",
    search: "Search",
    send: "Send",
    tryAgain: "Try again",
    upload: "Upload",
  },
  states: {
    loading: "Loading…",
    working: "Working…",
  },
  status: {
    scheduled: "Scheduled",
    recording: "Recording",
    processing: "Processing",
    ready: "Ready",
    failed: "Failed",
    partial: "Partial",
    uploadFailed: "Upload failed",
    waitingToBeLetIn: "Waiting to be let in",
  },
  platform: {
    zoom: "Zoom",
    google_meet: "Google Meet",
    teams: "Teams",
    upload: "Uploaded",
    studio: "Studio edit",
    youtube: "YouTube",
    linkedin: "LinkedIn",
  },
  roles: {
    user: "Member",
    creator: "Creator",
    admin: "Admin",
    super_admin: "Owner",
  },
  errors: {
    generic: "That did not work.",
    network: "Could not reach the server. Check your connection and try again.",
  },
  language: {
    label: "Language",
    choose: "Choose a language",
  },
  optional: "optional",
} as const;

export default common;
